import TagManager from 'react-gtm-module'

import { AnalyticsContext } from '../types/analytics'

export interface ModifyIncorrectEmailParams {
  context: AnalyticsContext
  previousEmail: string
  newEmail: string
}

const modifyIncorrectEmail = ({
  context,
  previousEmail,
  newEmail,
}: ModifyIncorrectEmailParams) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'modify_incorrect_email',
      context,
      previous_email: previousEmail,
      new_email: newEmail,
    },
  })
}

export default modifyIncorrectEmail
